import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const Collapse = ({ isOpen, children, className, ...props }) => {
  return (
    <div className={classnames({ 'd-none': !isOpen }, className)} {...props}>
      {children}
    </div>
  );
};

Collapse.propTypes = {
  isOpen: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
};

Collapse.defaultProps = {
  isOpen: false,
  children: null,
  className: null,
};

export default Collapse;
